import { apiClient } from '@/api/client';
import type { AcceptanceMethod, PolicyContent, UnacceptedPolicies } from '@/types/policy';
import {
  policyContentWireSchema,
  unacceptedPoliciesResponseWireSchema,
} from '../schemas/policy';
import type {
  ActivePoliciesResponseWire,
  PolicyVersionWire,
  UserPolicyAcceptanceWire,
} from '../schemas/policy';
import { mapPolicyContent, mapUnacceptedPolicies } from '../mappers/policy';

export async function getActivePolicies(): Promise<ActivePoliciesResponseWire> {
  return apiClient.get<ActivePoliciesResponseWire>('/api/v1/policies/active');
}

export async function getUnacceptedPolicies(): Promise<UnacceptedPolicies> {
  const response = await apiClient.get<unknown>('/api/v1/policies/unaccepted');
  return mapUnacceptedPolicies(unacceptedPoliciesResponseWireSchema.parse(response));
}

export async function getPolicyVersion(
  policyId: string,
  versionId: string
): Promise<PolicyVersionWire> {
  return apiClient.get<PolicyVersionWire>(
    `/api/v1/policies/${policyId}/versions/${versionId}`
  );
}

export async function getPolicyContent(
  policyId: string,
  versionId: string
): Promise<PolicyContent> {
  const response = await apiClient.get<unknown>(
    `/api/v1/policies/${policyId}/versions/${versionId}/content`
  );
  return mapPolicyContent(policyContentWireSchema.parse(response));
}

export async function acceptPolicy(
  policyId: string,
  versionId: string,
  acceptanceMethod: AcceptanceMethod
): Promise<UserPolicyAcceptanceWire> {
  return apiClient.post<UserPolicyAcceptanceWire>(
    `/api/v1/policies/${policyId}/versions/${versionId}/accept`,
    { acceptance_method: acceptanceMethod }
  );
}

export async function getUserPolicyAcceptances(): Promise<UserPolicyAcceptanceWire[]> {
  return apiClient.get<UserPolicyAcceptanceWire[]>('/api/v1/users/me/policy-acceptances');
}
